// 相机距离
export const cameraDis = 100;

// 原模型标识
export const originKey = 'origin';
export const processedKey = 'processed';
export const uvKey = 'uv';

// 对外展示的glb后缀
export const PUBLIC_SHOW_GLB_SUFFIX = '_public_show.glb';

// services服务相关设置（域名通过环境变量注入，见 .env.development / .env.production）
const dawn2ServerAddr = process.env.REACT_APP_SERVER_ADDR || 'https://www.dimgen.net/gtcenter';
let serverAddr = dawn2ServerAddr;

const developmentUrl = process.env.REACT_APP_SERVER_ADDR || "https://www.dimgen.net/gtcenter"
const deployUrls = [process.env.REACT_APP_DEPLOY_URL || "https://www.dimgen.net"];

// const serverAddr = 'https://9.134.83.216:7899';
export const SERVER_ADDR_KEY = 'ServerAddr_v2.0';
export const urlRegex = /^(https?:\/\/)?(([\w.-]+)\.([a-z]{2,})(:[0-9]+)?|(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(:[0-9]+)?|localhost(:[0-9]+)?)(\/\S*)?$/i;
export const GenesisTexDocumentUrl = "https://doc.weixin.qq.com/doc/w3_AXkAAQaaAMEgS53pqSlRwGHtMDXdc?scode=AJEAIQdfAAok33u1IqAXkAAQaaAME&roomid=Room%3A10820487087474669&version=4.1.32.6015&platform=win";

export const COLORS = ["#b03fae", "#c18401", "#51a250", "#4078f2", "#e45649"];
export const LABEL_COLORS= {};

export function setServerAddr(addr) {
  if (!urlRegex.test(addr)) {
    throw new Error('Invalid server address');
  }
  localStorage.setItem(SERVER_ADDR_KEY, addr);
  serverAddr = addr;
}

export function getServerAddr() {
  // 迁移保护：清理 localStorage 中残留的旧域名 justtest.asia/gtcenter，
  // 否则即使 env 指向 dimgen.net，本机仍会用老值 → RAG/SSO 永远 401。
  const stored = localStorage.getItem(SERVER_ADDR_KEY);
  if (stored && /justtest\.asia/i.test(stored)) {
    localStorage.removeItem(SERVER_ADDR_KEY);
  }
  const addr = localStorage.getItem(SERVER_ADDR_KEY) || serverAddr;
  if (!urlRegex.test(addr)) {
    throw new Error('Invalid server address');
  }
  serverAddr = addr;
  return serverAddr;
}

/** 登录后默认开启/关闭从COS拉取数据的功能 */
export const DEFAULT_FETCH_DATA_FROM_COS = true;
/** 使用预签名URL拉取COS文件，代替直接使用API从COS拉取文件 */
export const USE_SIGNED_URL_FOR_COS = true;

export const generateUrl = (token) => {
  const env = process.env.NODE_ENV || 'development';
  if (env === 'development') {
    return developmentUrl + '/share?token=' + token;
  }
  // 正式环境 默认全部使用外网
  return deployUrls[0] + '/share?token=' + token;
}

export const PromptsLenLimit = 30;
export const MeshesPerPage = 40;

export const backgroundColor = 0xa0a0a0;
export const AxesName = 'AxesHelper';

export const TransformControlName = "RotateControl";
export const BoxLength = 2;
export const AmbientLightName = "AmbientLight";
export const SpotLightName = "SpotLight";

export function getReqParam(method='POST') {
  const env = process.env.NODE_ENV || 'development';

  const param = {
    method: method,
    mode: 'cors',
    credentials: 'include',
  }

  return param;

}

export function isAdmin() {
  return (localStorage.getItem('organization') === 'master' || localStorage.getItem('organization') === 'admin')
}

/** 判断mesh_info中的字段key对应的值是否属于路径 */
export function mayKeyContainPath(key) {
  return key.endsWith('path') || key.endsWith('dir');
}

export const MeshCardStatus = {
  ORG: 'org',
  PENDING: 'pending',
  FAILED: 'failed',
  RUNNING: 'running',
  SUCCESS: "success",
  SINGLE_REPAIR_RUNNING: 'single_view_repair_running',
  FACE_REPAIR_RUNNING: 'face_repair_running',
  REFINE_RUNNING: 'refine_running',
  DELIGHT_RUNNING: 'delight_running',
  GENERATE_PBR_RUNNING: 'generate_pbr_running',
}

export const ENABLE_ENCRYPTED = true;

export const TASK_TYPE = {
  SingleViewTask: '单视角修复',
  FaceFixTask: '脸部修复',
  RefineTask: '贴图精修',
  DelightTask: '去高光&阴影',
  ReplaceTexture: "贴图区域替换",
  // 非単视角
  GeneratePBR: '生成PBR贴图',
}

export const SINGLE_VIEW_TASK = {
  [TASK_TYPE.SingleViewTask]: true,
  [TASK_TYPE.FaceFixTask]: true,
  [TASK_TYPE.RefineTask]: true,
  [TASK_TYPE.DelightTask]: true,
  [TASK_TYPE.ReplaceTexture]: true,
}

export const TASK_TYPE_DB_IDS = {
  [TASK_TYPE.SingleViewTask]: "SingleViewTaskIds",
  [TASK_TYPE.FaceFixTask]: "FaceFixTaskIds",
  [TASK_TYPE.RefineTask]: "RefineTaskIds",
  [TASK_TYPE.DelightTask]: "DelightTaskIds",
  [TASK_TYPE.GeneratePBR]: "GeneratePBRTaskIds",
};
export const TASK_TYPE_DB_IDS_TASK_TYPE = Object.fromEntries(Object.entries(TASK_TYPE_DB_IDS).map((entry) => entry.reverse()));

export const TASK_TYPE_MeshCardStatus = {
  [TASK_TYPE.SingleViewTask]: MeshCardStatus.SINGLE_REPAIR_RUNNING,
  [TASK_TYPE.FaceFixTask]: MeshCardStatus.FACE_REPAIR_RUNNING,
  [TASK_TYPE.RefineTask]: MeshCardStatus.REFINE_RUNNING,
  [TASK_TYPE.DelightTask]: MeshCardStatus.DELIGHT_RUNNING,
  [TASK_TYPE.GeneratePBR]: MeshCardStatus.GENERATE_PBR_RUNNING,
};
export const MeshCardStatus_TASK_TYPE = Object.fromEntries(Object.entries(TASK_TYPE_MeshCardStatus).map((entry) => entry.reverse()));

/**
 * 计算提示词的长度，中文字符算1个，英文5个字母算1个
 * @param {string} text - 要计算长度的文本
 * @returns {number} - 计算后的长度
 */
export function calculatePromptLength(text) {
  if (!text) return 0;

  // 匹配中文字符
  const chineseChars = text.match(/[\u4e00-\u9fa5]/g) || [];
  // 匹配英文字符
  const englishChars = text.match(/[a-zA-Z]/g) || [];

  // 中文字符每个算1个长度
  const chineseLength = chineseChars.length;
  // 英文字符每5个算1个长度，不足5个的部分算1个
  const englishLength = Math.ceil(englishChars.length / 5);

  return chineseLength + englishLength;
}

/** 本地调试PBR显示功能 */
export const LOCAL_PBR_DISPLAY_DEBUG = false;
export const LOCAL_DISPLAY_WITH_ENCRYPTED = true;
/** 本地调试PBR生成功能（正式环境默认为true） */
export const LOCAL_PBR_WORKFLOW_DEBUG = true;
/** @deprecated 使用shader解密，有可能影响画质，但更容易适配glb也更难被截帧（未完成） */
export const USE_SHADER_ENCRYPT = false;
/** 启用生成glb中间结果（正式环境默认为true） */
export const ENABLE_GLB_GENERATION = true;
/** 启aes加密贴图（正式环境默认为true） */
export const ENCRYPT_TEXTURES_BY_AES = true;
